import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";


const codecT = t.type({
		acknowledged: t.boolean,
		modifiedCount: t.number,
		upsertedId: t.union([t.string, t.null]),
		upsertedCount: t.number,
		matchedCount: t.number
	})
export const taskPinCommentMutation = ({
  noteId
}: {
  noteId:string
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/${noteId}/pin`,
    codec: codecT,
  })

export const taskUnPinCommentMutation = ({
  noteId
}: {
  noteId: string
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'PUT',
    pathname: `/tasks/${noteId}/unpin`,
    codec: codecT,
  })
